import { create } from 'zustand';

type CRMStage = 'new' | 'rpc' | 'aod' | 'pending_arrangement' | 'qc' | 'active' | 'soft' | 'admin_dc' | 'no_contact' | 'customer_care';

interface DebtorCase {
  id: string;
  account_id: number;
  stage: CRMStage;
  next_action_at: string | null;
  neg_outcomes_count: number;
  metadata: any;
}

interface CRMStore {
  cases: DebtorCase[];
  selectedCase: DebtorCase | null;
  stageFilter: CRMStage | 'all';
  setCases: (cases: DebtorCase[]) => void;
  setSelectedCase: (caseData: DebtorCase | null) => void;
  setStageFilter: (stage: CRMStage | 'all') => void;
  updateCaseStage: (id: string, stage: CRMStage) => void;
}

export const useCRMStore = create<CRMStore>((set) => ({
  cases: [],
  selectedCase: null,
  stageFilter: 'all',
  setCases: (cases) => set({ cases }),
  setSelectedCase: (caseData) => set({ selectedCase: caseData }),
  setStageFilter: (stage) => set({ stageFilter: stage }),
  updateCaseStage: (id, stage) => set((state) => ({
    cases: state.cases.map(c => c.id === id ? { ...c, stage } : c),
    selectedCase: state.selectedCase?.id === id 
      ? { ...state.selectedCase, stage }
      : state.selectedCase,
  })),
}));
